export default function httpConfig($httpProvider) {
  'ngInject';

  ///////////////////////////
  // Configure HTTP Settings
  ///////////////////////////

  // set the default header content-type to application/json for DELETE - we sometimes send JSON data on delete
  if (!$httpProvider.defaults.headers.delete) {
    $httpProvider.defaults.headers.delete = {};
  }
  $httpProvider.defaults.headers.delete['Content-Type'] = 'application/json';

  // Turn caching off by default.  We wanted to have this on so multiple requests
  // to the same url at the same time result in only on request.
  // However, this led to caching GETs which caused update issues with our REST APIs.
  $httpProvider.defaults.cache = false;
  // Improve performance during bootstrap when there are many http requests at once.
  $httpProvider.useApplyAsync(true);
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/core/http/http.config.js